import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';

import { theme } from '../Theme';

const CategoriesWrapper = styled('div')`
  display: flex;
  align-items: center;
  border-left: 1px solid #181818;
  ${theme.below.lg} {
    flex-wrap: wrap;
    margin: 0 20px;
    border: 0;
    justify-content: center;
  }
`;
const CategoryLink = styled(Link)`
  width: 100%;
  padding: 15px 0;
  border: 1px solid #181818;
  border-left: 0;
  color: ${theme.colors.black};
  font-size: 0.8rem;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  transition: all, 0.2s ease;
  &:hover {
    background: ${theme.colors.black};
    color: white !important;
  }
  ${theme.below.lg} {
    width: 32%;
    border-bottom: 0;
    font-size: 0.7rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 45px;
    line-height: 1.3;

    border: 0;
    outline: 1px solid #181818;
    margin-left: 1px;
    margin-bottom: 1px;
    padding: 0 5px;
  }
`;

export const CategoryItem = ({ link, text, children }) => (
  <CategoryLink to={children.props.link}>
    {children.props.children}
  </CategoryLink>
);

const Categories = ({ children }) => {
  if (children && children.length > 0) {
    return (
      <CategoriesWrapper>
        {children.map((child, index) => (
          <CategoryItem
            index={index}
            text={child.text}
            link={child.link}
            children={child}
          />
        ))}
      </CategoriesWrapper>
    );
  } else {
    return null;
  }
};

export default Categories;
